export default __webpack_public_path__ + "static/media/bank.f26a94b8.svg";